import {
  type MutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { z } from 'zod';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';

export interface RedeemAccessCodeParams {
  accessCode: string;
  userId: string;
}

const redeemedAccessCodeShape = z.object({
  accessCode: z.string(),
  endDate: z.string(),
  id: z.string(),
  productId: z.string(),
  startDate: z.string(),
  subscriptionId: z.string(),
});
export type RedeemedAccessCode = z.infer<typeof redeemedAccessCodeShape>;

export async function redeemAccessCodeApi({
  accessCode,
  userId,
}: RedeemAccessCodeParams): Promise<RedeemedAccessCode> {
  return fetcher(`/access-codes/${accessCode}/redeem`, {
    method: 'POST',
    service: '/fulfillment',
    version: '/v1',
    queryParameters: { userId },
  });
}

export function useRedeemAccessCodeApi(
  customMutationOptions?: Omit<
    MutationOptions<RedeemedAccessCode, ApiError, RedeemAccessCodeParams>,
    'mutationFn'
  >
): UseMutationResult<RedeemedAccessCode, ApiError, RedeemAccessCodeParams> {
  return useMutation({
    mutationFn: redeemAccessCodeApi,
    ...customMutationOptions,
  });
}
